import React, { Component } from "react"
import config from "react-global-configuration"
import * as endpoints from "../../constants/Endpoints"
import axios from "axios"
import SimpleErrorModal from "../../../shared/modal/simple-error-modal"
class CheckoutVechicleInformation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showErrorModal: false,
      modalOpen: true,
      timeout: undefined,
      loaderActive: false,
    }
  }

  handleInputChange(event, maxLength) {
    const { target } = event
    const value = target.value.slice(0, maxLength)
    const name = target.name
    this.updateVehicleInformation(name, value)
  }

  updateVehicleInformation = (name, value) => {
    let newVechicleInformation = this.props.vechicleInformation
    newVechicleInformation[name] = value
    this.props.updateCheckoutState("vechicleInformation", newVechicleInformation, this.props.getRequiredFields())
  }

  handleLicensePlateInput = (event, maxLength) => {
    this.handleInputChange(event, maxLength)
    const target = event.target
    const value = target.value
    if (this.state.timeout) {
      clearTimeout(this.state.timeout)
      this.setState({ timeout: undefined })
    }
    this.setState({
      timeout: setTimeout(() => {
        if (value.replaceAll(/\s/g, "").length >= 7) {
          target.blur()
        }
      }, 300),
    })
  }

  verifyLicensePlate = (value) => {
    if (value.length > 0) {
      this.setState({ loaderActive: true })
      axios
        .get(endpoints.VERIFY_LICENSE_PLATE(value))
        .then((res) => {
          if (res && res.status === 204) {
            this.showErrorModal(value)
          }
          return res.data
        })
        .then((data) => {
          for (const key in data) {
            switch (key) {
              case "make":
                this.updateVehicleInformation("vehicleMake", data.make)
                break
              case "model":
                this.updateVehicleInformation("vehicleModel", data.model)
                break
              case "color":
                this.updateVehicleInformation("vehicleColour", data.color)
                break
              case "licensePlate":
                this.updateVehicleInformation({ vehicleRegistrationNumber: data.licensePlate })
                break
              default:
                break
            }
          }
        })
        .finally(() => {
          this.setState({ loaderActive: false })
        })
    }
  }

  showErrorModal(input) {
    const textKeys = config.get("textKeys.checkout.vehicleRegistrationValidationModal") || {}
    this.setState({
      showErrorModal: true,
      errorData: {
        h3: textKeys.vehicleRegistrationModalErrorHeader || "Din nummerplade kunne ikke valideres",
        richText:
          textKeys.vehicleRegistrationModalErrorMessage?.replace("{value}", input) ||
          "<p>Er du sikker på at <strong>{value}</strong> er en gyldig nummerplade?</p>".replace("{value}", input),
      },
    })
  }

  handleModalClose = () => {
    this.setState({ showErrorModal: false })
  }

  render() {
    const { booking, modificationSummary } = this.props.bookingResult
    const { checkoutErrors, vechicleInformation } = this.props
    const textKeys = config.get("textKeys.checkout.vechicleInformation") || {}
    const validationTextKeys = config.get("textKeys.checkout.vehicleValidationMessages") || {}

    const isVehicleRegistrationNumberRequired = !!(
      booking &&
      booking.overrideFields &&
      booking.overrideFields.find((e) => e.fieldName === "VehicleRegistrationNumber" && e.mandatory === true)
    )
    const isVehicleMakeRequired = !!(
      booking &&
      booking.overrideFields &&
      booking.overrideFields.find((e) => e.fieldName === "VehicleMake" && e.mandatory === true)
    )
    const isVehicleModelRequired = !!(
      booking &&
      booking.overrideFields &&
      booking.overrideFields.find((e) => e.fieldName === "VehicleModel" && e.mandatory === true)
    )
    const isVehicleColourRequired = !!(
      booking &&
      booking.overrideFields &&
      booking.overrideFields.find((e) => e.fieldName === "VehicleColour" && e.mandatory === true)
    )

    const isUpgrade = !!modificationSummary
    if (isUpgrade && !isVehicleRegistrationNumberRequired && !isVehicleMakeRequired && !isVehicleModelRequired && !isVehicleColourRequired)
      return null

    const registrationNumberError = isVehicleRegistrationNumberRequired && checkoutErrors.vehicleRegistrationNumber
    const vehicleMakeError = isVehicleMakeRequired && checkoutErrors.vehicleMake
    const vehicleModelError = isVehicleModelRequired && checkoutErrors.vehicleModel
    const vehicleColourError = isVehicleColourRequired && checkoutErrors.vehicleColour

    // const anyVehicleError = registrationNumberError || vehicleMakeError || vehicleModelError || vehicleColourError

    const vehicleErrorArray = [registrationNumberError, vehicleMakeError, vehicleModelError, vehicleColourError]
    var count = 0
    vehicleErrorArray.forEach((e) => (e ? count++ : null))
    const moreThanOneVechicleError = count > 1

    return (
      <div className="form--parking__vechicle-info">
        <header className={"form__header"}>
          <h4>{textKeys.header || "Bilens oplysninger"}</h4>
          <p>{textKeys.subtitle || "Nummerpladegenkendelse"}</p>
        </header>
        <div className={"form__section form__section--short form__section--light"}>
          <div className={"form__section__inner d-flex--md"}>
            <div
              className={`form__field form__field--text ${isVehicleRegistrationNumberRequired ? "is-required" : ""} ${
                vechicleInformation.vehicleRegistrationNumber && vechicleInformation.vehicleRegistrationNumber?.length > 0 ? "is-filled" : ""
              } ${
                (checkoutErrors.vehicleRegistrationNumber && checkoutErrors.showErrors) || vechicleInformation.vehicleRegistrationNumber?.length > 20
                  ? "is-invalid"
                  : ""
              } is-bound`}
            >
              <span className="form__valid" />
              <input
                className={`form__item`}
                tabIndex="10"
                name="vehicleRegistrationNumber"
                type="text"
                value={vechicleInformation.vehicleRegistrationNumber}
                onChange={(event) => this.handleLicensePlateInput(event, 20)}
                onBlur={(event) => this.verifyLicensePlate(event.target.value)}
              />
              <label htmlFor="vehicleRegistrationNumber" className="form__label">
                <span className="form__label__text">
                  {textKeys.vehicleRegistrationNumber || "Registreringsnr."}&nbsp;
                  <i>{!isVehicleMakeRequired && textKeys.vehicleOptional ? textKeys.vehicleOptional : ""}</i>&nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
              {this.state.loaderActive ? <div className={"input-spinner"}></div> : ""}
              {isVehicleRegistrationNumberRequired && checkoutErrors.vehicleRegistrationNumber && checkoutErrors.showErrors ? (
                <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
              ) : (
                ""
              )}
              {vechicleInformation.vehicleRegistrationNumber?.length > 20 ? (
                <span className="form__notice">
                  {this.props.validationMessageReplace(
                    vechicleInformation.vehicleRegistrationNumber,
                    validationTextKeys.vehicleRegistrationNumberMessage,
                  ) || "Dit input er for langt."}
                </span>
              ) : null}
            </div>
            <div
              className={`form__field form__field--text ${isVehicleMakeRequired ? "is-required" : ""} ${
                vechicleInformation.vehicleMake && vechicleInformation.vehicleMake?.length > 0 ? "is-filled" : ""
              } ${
                (checkoutErrors.vehicleMake && checkoutErrors.showErrors) || vechicleInformation.vehicleMake?.length > 50 ? "is-invalid" : ""
              } is-bound`}
            >
              <span className="form__valid" />
              <input
                className="form__item "
                tabIndex="11"
                type="text"
                name="vehicleMake"
                value={vechicleInformation.vehicleMake}
                onChange={(event) => this.handleInputChange(event, 50)}
              />
              <label htmlFor="vehicleMake" className="form__label">
                <span className="form__label__text">
                  {textKeys.vehicleMake || "Mærke"}&nbsp;<i>{!isVehicleMakeRequired && textKeys.vehicleOptional ? textKeys.vehicleOptional : ""}</i>
                  &nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
              {isVehicleMakeRequired && checkoutErrors.vehicleMake && checkoutErrors.showErrors ? (
                <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
              ) : (
                ""
              )}
              {vechicleInformation.vehicleMake?.length > 50 ? (
                <span className="form__notice">
                  {this.props.validationMessageReplace(vechicleInformation.vehicleMake, validationTextKeys.vehicleMakeMessage) ||
                    "Dit input er for langt."}
                </span>
              ) : null}
            </div>
          </div>
          <div className={"form__section__inner d-flex--md"}>
            <div
              className={`form__field form__field--text ${isVehicleModelRequired ? "is-required" : ""} ${
                vechicleInformation.vehicleModel && vechicleInformation.vehicleModel?.length > 0 ? "is-filled" : ""
              } ${
                (checkoutErrors.vehicleModel && checkoutErrors.showErrors) || vechicleInformation.vehicleModel?.length > 80 ? "is-invalid" : ""
              } is-bound`}
            >
              <span className="form__valid" />
              <input
                className="form__item "
                tabIndex="12"
                type="text"
                name="vehicleModel"
                value={vechicleInformation.vehicleModel}
                onChange={(event) => this.handleInputChange(event, 80)}
              />
              <label htmlFor="vehicleModel" className="form__label">
                <span className="form__label__text">
                  {textKeys.vehicleModel || "Model"}&nbsp;<i>{!isVehicleMakeRequired && textKeys.vehicleOptional ? textKeys.vehicleOptional : ""}</i>
                  &nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
              {isVehicleModelRequired && checkoutErrors.vehicleModel && checkoutErrors.showErrors ? (
                <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
              ) : (
                ""
              )}
              {vechicleInformation.vehicleModel?.length > 80 ? (
                <span className="form__notice">
                  {this.props.validationMessageReplace(vechicleInformation.vehicleModel, validationTextKeys.vehicleModelMessage) ||
                    "Dit input er for langt."}
                </span>
              ) : null}
            </div>
            <div
              className={`form__field form__field--text ${isVehicleColourRequired ? "is-required" : ""} ${
                vechicleInformation.vehicleColour && vechicleInformation.vehicleColour?.length > 0 ? "is-filled" : ""
              } ${
                (checkoutErrors.vehicleColour && checkoutErrors.showErrors) || vechicleInformation.vehicleColour?.length > 20 ? "is-invalid" : ""
              } is-bound`}
            >
              <span className="form__valid" />
              <input
                className="form__item "
                tabIndex="13"
                type="text"
                name="vehicleColour"
                value={vechicleInformation.vehicleColour}
                onChange={(event) => this.handleInputChange(event, 20)}
              />
              <label htmlFor="vehicleColour" className="form__label">
                <span className="form__label__text">
                  {textKeys.vehicleColour || "Farve"}&nbsp;<i>{!isVehicleMakeRequired && textKeys.vehicleOptional ? textKeys.vehicleOptional : ""}</i>
                  &nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
              {isVehicleColourRequired && checkoutErrors.vehicleColour && checkoutErrors.showErrors ? (
                <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
              ) : (
                ""
              )}
              {vechicleInformation.vehicleColour?.length > 20 ? (
                <span className="form__notice">
                  {this.props.validationMessageReplace(vechicleInformation.vehicleColour, validationTextKeys.vehicleColourMessage) ||
                    "Dit input er for langt."}
                </span>
              ) : null}
            </div>
          </div>
        </div>

        {this.state.showErrorModal ? (
          <SimpleErrorModal errorData={this.state.errorData} modalOpen={this.state.modalOpen} closeHandler={this.handleModalClose} />
        ) : (
          ""
        )}

        {moreThanOneVechicleError && checkoutErrors.showErrors ? (
          <span className={"form__notice form__notice--box is-invalid"}>
            {textKeys.vehicleErrorMessage || "Du skal udfylde disse felter pga..."}
            {/* {moreThanOneVechicleError?`${textKeys.multipleRequired || "Du skal udfylde disse felter"}: ` :""}
                      {registrationNumberError?`${textKeys.vehicleRegistrationNumber || "Registreringsnr."} `:""}
                      {vehicleMakeError?`${textKeys.vehicleMake || "Registreringsnr."} `:""}
                      {vehicleModelError?`${textKeys.vehicleModel || "Registreringsnr."} `:""}
                      {vehicleColourError?`${textKeys.vehicleColour || "Registreringsnr."} `:""} */}
          </span>
        ) : (
          ""
        )}
      </div>
    )
  }
}
export default CheckoutVechicleInformation
